module.exports = __webpack_public_path__ + "static/bg-citrix-fc741ff5ed310fc9a66c23d0f4fb6f1a.webp";